import Review from "../../../../src/pages/toolkit/design/review/review";
import * as React from 'react';
export default {
  Review,
  React
};